import { createPinia } from 'pinia';

export const pinia = createPinia();
export type PiniaInstance = typeof pinia;
